import React from "react";
import { CheckCircle2, Loader } from "lucide-react";

export default function ExceptionCenter({ exceptions, loading }) {
    return (
        <div className="bg-[#111827] border border-[#1F2937] rounded-xl p-4 flex-1">
            <div className="flex items-center justify-between mb-3">
                <p className="text-sm font-bold text-white">Exception Center</p>
                <span className="text-[11px] text-slate-500">
                    {loading ? "—" : `${exceptions.length} issues`}
                </span>
            </div>
            {loading ? (
                <div className="flex items-center justify-center h-24 text-slate-700">
                    <Loader size={18} className="animate-spin"/>
                </div>
            ) : exceptions.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-24 gap-2">
                    <CheckCircle2 size={22} className="text-green-500"/>
                    <p className="text-xs text-slate-400">No exceptions — all clear</p>
                </div>
            ) : (
                <div className="space-y-2.5">
                    {exceptions.map((e, i) => (
                        <div key={i} className="flex items-center gap-2.5">
                            <div className="w-7 h-7 rounded-lg bg-[#1F2937] flex items-center justify-center text-sm shrink-0">{e.icon}</div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-semibold text-slate-200 truncate">{e.label}</p>
                                <p className="text-[10px] text-slate-500">{e.sub}</p>
                            </div>
                            <div className="text-right shrink-0">
                                <p className="text-[10px] text-slate-600">{e.ago}</p>
                                <span className="inline-block mt-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold"
                                    style={{backgroundColor:`${e.color}22`,color:e.color}}>
                                    {e.count}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
